module.exports = __webpack_public_path__ + "761b69d4f024d8700a4112f9aefd9bde.svg";